// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1J-F_","title":"Header_title__3fJaP","left":"Header_left__3lU3h","clinicName":"Header_clinicName__3BSGM"};